<style lang="scss" scoped>
	@import "../../manage-seller-groups/manage-seller-groups.modal";
.modal-mask {
  position: fixed;
  z-index: 4;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.3s ease;
  -webkit-overflow-scrolling: touch;
}
.modal-content-container {
  background-color: white;
  min-width: 80vw;
  border-radius: 12px;
}
.seller-groups__main-container {
  width: 100%;
  height: 100%;
  max-height: 100%;
  overflow: hidden;
}
.seller-groups__header-title {
  color: #ffffff;
  letter-spacing: -2%;
  font-weight: 500;
  font-size: 32px;
}
.seller-groups__closebtn-icon {
  color: #ffffff;
  font-size: 30px;
  cursor: pointer;
}
.seller-groups__containers-wrapper {
  display: flex;
  padding: 0px 0px;
  margin: 0px;
  justify-content: space-evenly;
  align-items: center;
}
.seller-groups__content-wrapper {
  width: 36vw;
  height: 63vh;
  border-radius: 8px;
  display: flex;          // 🔥
  flex-direction: column; // 🔥
  min-height: 0;          // 🔥 importantíssimo
}
.seller-groups__title-wrapper {
  margin: 10px;
}
.seller-groups__title {
  color: #707070;
  font-weight: 400;
  font-size: 26px;
}
.seller-groups__input-wrapper {
  margin: 0px 0px 10px 10px;
  display: flex;
  align-items: center;
  width: 34.8vw;
}
.seller-groups__input {
  width: 35vw;
  height: 5vh;
  padding: 0px 0px 0px 8px;
  border-top: 0.65px solid #e5e5e5;
  border-left: 0.65px solid #e5e5e5;
  border-bottom: 0.65px solid #e5e5e5;
  border-right: none;
  border-radius: 5.23px 0px 0px 5.23px;
  font-weight: 400;
  font-size: 14px;
  color: #a1a1a1;
}
.seller-groups__input:focus {
  outline: none !important;
  border: 0.65px solid var(--primary-color);
}
.seller-groups__input-icon {
  position: relative;
  left: -1.2px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--primary-color);
  background-color: var(--primary-color);
  width: 4vw;
  height: 5vh;
  border-radius: 0px 5px 5px 0px;
  border-top: 0.65px solid #e5e5e5;
  border-bottom: 0.65px solid #e5e5e5;
  border-right: 0.65px solid #e5e5e5;
}
.seller-groups__table-container {
  flex: 1 1 auto;   // 🔥 ocupa o resto do card
  overflow-y: auto;
  overflow-x: auto;
  min-height: 0;    // 🔥 evita corte do último item
}

.seller-groups__table-wrapper {
}
.seller-groups__table-thead {
}
.seller-groups__table-thead-tr {
  background-color: #fffefc;
  border: 0.5px solid #e5e5e5;
  color: #605f5f;
  font-size: 14px;
  font-weight: 400;
}
.seller-groups__table-th {
  font-family: Rubik;
  font-size: 14px;
  font-weight: 600;
}
.seller-groups__table-tbody {
  border: 0.33px solid #e5e5e5;
}
.seller-groups__table-td {
  font-family: Rubik;
  color: #707070;
  font-size: 14px;
  font-weight: 300;
}
.seller-groups__table-td__icons-wrapper {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}
.save-icon {
  color: var(--primary-color);
  cursor: pointer;
}
.edit-icon {
  color: #605f5f;
  cursor: pointer;
  margin-right: 5px;
}
.trash-icon {
  color: #cd2a2a;
  cursor: pointer;
}
.plus-icon {
  color: var(--primary-color);
  cursor: pointer;
}
.select-icon {
  color: var(--primary-color);
}
.selected {
  background-color: #f0f0f1;
}
.disabled {
  cursor: not-allowed !important;
}
.page-table-line-special {
  background: #f7f7f7;
}
.middle-table::-webkit-scrollbar {
  display: none; // Safari and Chrome
}

@media only screen and (min-width: 1440px) {
  .seller-groups__table-th {
    font-size: 20px;
  }
  .seller-groups__table-td {
    font-size: 20px;
  }
  .seller-groups__actions-title {
    font-size: 22px;
  }
  .seller-groups__title {
    font-size: 32px;
  }
  .seller-groups__input {
    font-size: 18px;
  }
}

@media only screen and (max-width: 750px) {
  .seller-groups__containers-wrapper {
    flex-direction: column;
    padding-bottom: 4px;
    margin: 10px 0px;
  }
  .seller-groups__main-container {
    overflow-y: auto;
  }
  .seller-groups__content-wrapper {
    width: 100vw;
    height: auto;
    margin: 7px;
  }
  .seller-groups__input-wrapper {
    width: 95vw;
  }
  .seller-groups__input-wrapper {
  }
  .seller-groups__input-icon {
    width: 15vw;
  }
  .seller-groups__input {
    width: 100vw;
  }
  .select-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    top: 10px;
  }
  .table-input {
    width: 40vw;
  }
  .th-center {
    text-align: center;
  }
}

@media only screen and (max-width: 500px) {
  .seller-groups__main-container {
    max-width: 110vw;
    padding-bottom: 20px;
    margin: 0 auto;
  }
}

@supports (-webkit-touch-callout: none) {
  .modal-mask {
    padding: 0;
    align-items: flex-start;
  }

  .modal-content-container {
    max-height: 90vh;
    border-radius: 0;
    width: 80vw;
    height: 80vh;
  }

  .seller-groups__containers-wrapper {
    height: 100%;
    overflow-y: auto;
  }
}

</style>
<template>
	<div class="modal-content-container">
      <div class="seller-groups__main-container">
	      <div v-show="!loading" class="seller-groups__containers-wrapper">
          <div class="seller-groups__content-wrapper">
            <div class="seller-groups__title-wrapper">
              <span class="seller-groups__title">Grupos</span>
              <cc-loader v-show="is_loading_request_sellers" />
            </div>
            <div class="seller-groups__input-wrapper">
              <input
                placeholder="Digite o nome do Grupo"
                class="seller-groups__input"
                type="text"
                v-model="new_group.nome"
                @keyup.enter="create"
              />
              <span
                @click="create"
                style="color: #fff"
                class="material-icons-outlined seller-groups__input-icon plus-icon"
              >
                add
              </span>
            </div>
            <div class="seller-groups__table-container first-table">
              <table class="seller-groups__table-wrapper">
                <thead class="seller-groups__table-thead">
                  <tr class="seller-groups__table-thead-tr">
                    <th class="seller-groups__table-th th-center">#ID</th>
                    <th class="seller-groups__table-th th-center">Nome</th>
                    <th class="seller-groups__table-th th-center">Ação</th>
                  </tr>
                </thead>
                <tbody class="seller-groups__table-tbody">
                  <tr
                    v-show="group.visible"
                    v-for="group in groups"
                    :key="group.id"
                    :class="{ selected: group.selected }"
                  >
                    <td class="seller-groups__table-td select-icon">
                      <i v-show="group.selected" class="fas fa-hand-point-right mr-2"></i
                      ><b>#{{ group.id }}</b>
                    </td>
                    <td v-if="group.selected" class="seller-groups__table-td table-input">
                      <cc-input v-model="group.nome" />
                    </td>
                    <td v-else class="seller-groups__table-td table-input">
                      <cc-input disabled v-model="group.nome" />
                    </td>
                    <td class="seller-groups__table-td">
                      <div class="seller-groups__table-td__icons-wrapper">
                        <span
                          v-if="!group.selected"
                          @click.stop="select_group(group)"
                          class="material-icons-outlined edit-icon"
                          >edit</span
                        >
                        <span
                          v-if="group.selected"
                          @click="update(group)"
                          class="material-icons-outlined save-icon"
                          >save</span
                        >
                        <span
                          class="material-icons-outlined trash-icon"
                          v-show="!group.loading"
                          @click.stop="remove_group(group)"
                          >delete</span
                        >
                        <cc-loader
                          v-show="group.loading"
                          :show_txt="false"
                          class="loader float-right"
                        />
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="seller-groups__content-wrapper">
            <div class="seller-groups__title-wrapper">
              <span v-if="group.selected && addBtnSelected" class="seller-groups__title">{{
                group.nome
              }}</span>
              <span v-if="!group.selected || !addBtnSelected" class="seller-groups__title"
                >Selecione um grupo</span
              >
            </div>
            <div class="seller-groups__input-wrapper">
              <input
                placeholder="Digite o nome do Fornecedor"
                class="seller-groups__input"
                type="text"
                @keyup.enter="load_added_sellers"
                v-model="added_provider_name"
                :disabled="!group.selected"
              />
              <span
                @click="load_added_sellers"
                style="color: #fff"
                class="material-icons-outlined seller-groups__input-icon plus-icon"
              >
                search
              </span>
            </div>
            <div class="seller-groups__table-container middle-table">
              <table class="seller-groups__table-wrapper">
                <thead class="seller-groups__table-thead">
                  <tr class="seller-groups__table-thead-tr">
                    <th class="seller-groups__table-th">Fornecedor</th>
                    <th class="seller-groups__table-th">Vendedor</th>
                    <th class="seller-groups__table-th"></th>
                  </tr>
                </thead>
                <tbody class="seller-groups__table-tbody">
                  <tr
                    v-for="(seller, idx) in group_sellers"
                    :key="seller.id"
                    :class="{ 'page-table-line-special': idx % 2 != 0 }"
                  >
                    <td class="seller-groups__table-td">
                      <b style="color: var(--primary-color)">{{
                        seller.provider.for_nome
                      }}</b>
                    </td>
                    <td class="seller-groups__table-td">{{ seller.usu_nome }}</td>
                    <td class="seller-groups__table-td">
                      <span
                        class="material-icons-outlined trash-icon"
                        v-show="!seller.loading"
                        @click.stop="remove_seller(seller)"
                        >delete</span
                      >
                      <cc-loader
                        style="width: 30px"
                        v-show="seller.loading"
                        :show_txt="false"
                        class="loader float-right"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="seller-groups__content-wrapper">
            <div class="seller-groups__title-wrapper">
              <span class="seller-groups__title">Fornecedores disponíveis</span>
              <cc-loader v-show="is_loading_available_sellers" />
            </div>
            <div class="seller-groups__input-wrapper">
              <input
                placeholder="Digite o nome do Fornecedor"
                class="seller-groups__input"
                type="text"
                @keyup.enter="load_sellers"
                v-model="provider_name"
              />
              <span
                @click="load_sellers"
                style="color: #fff"
                class="material-icons-outlined seller-groups__input-icon plus-icon"
              >
                search
              </span>
            </div>
            <div class="seller-groups__table-container">
              <table class="seller-groups__table-wrapper">
                <thead class="seller-groups__table-thead">
                  <tr class="seller-groups__table-thead-tr">
                    <th class="seller-groups__table-th"></th>
                    <th class="seller-groups__table-th">Fornecedor</th>
                    <th class="seller-groups__table-th">Vendedor</th>
                  </tr>
                </thead>
                <tbody class="seller-groups__table-tbody">
                  <tr
                    v-for="(seller, idx) in sellers"
                    :key="seller.id"
                    v-show="!seller.disabled"
                    :class="{
                      disabled: seller.disabled || !group.id,
                      'page-table-line-special': idx % 2 != 0,
                    }"
                  >
                    <td class="seller-groups__table-td">
                      <cc-loader
                        style="width: 30px"
                        v-show="seller.loading"
                        :show_txt="false"
                        class="loader float-right"
                      />
                      <span
                        v-show="
                          !seller.loading &&
                          seller.disabled != true &&
                          group.id &&
                          addBtnSelected
                        "
                        :class="{ disabled: seller.disabled }"
                        :disabled="seller.disabled"
                        @click.stop="add(seller)"
                        class="material-icons-outlined plus-icon"
                        >add</span
                      >
                    </td>
                    <td class="seller-groups__table-td">
                      <b style="color: var(--primary-color)">{{ seller.provider.name }}</b>
                    </td>
                    <td class="seller-groups__table-td">{{ seller.name }}</td>
                  </tr>
                  <tr v-if="filters.per_page <= filters.total_items">
                    <td colspan="3">
                      <div class="box-footer clearfix not-print">
                        <cc-pagination
                          :key="'pag'"
                          classes="orange"
                          :total="filters.total_items"
                          :page="page"
                          :page_limit="11"
                          :items_by_page_value="filters.per_page"
                          v-on:change="load_sellers($event)"
                        >
                        </cc-pagination>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
	</div>
</div>
</template>

<script>

import SellersService from "@/services/v2/sellers.service";
import RequestsService from "@/services/v2/requests.service";
import SellerGroupService from "@/services/v3/seller-group.service";
import ErrorHandlerService from '@/services/ErrorHandlerService';
import Pagination from "@/components/cliente/base-components/Pagination";
import { loaderMixin } from '@/mixins/sweet-loader.mixin';

export default {
	mixins: [ loaderMixin ],
	props: ["buyer"],
	components: {
		ccPagination : Pagination
   },
  	data() {
		return {
      addBtnSelected: false,
      sellers: [],
      request_sellers: [],
      groups: [],
      group_sellers: [],
      page: 1,
      filters: {
        name: "",
        total_items: 0,
        per_page: 0,
      },
      loading: false,
      is_loading_available_sellers: false,
      is_loading_request_sellers: false,
      service: new SellersService(),
      group_svc: new SellerGroupService(),
      req_svc: new RequestsService(),
      modal: {
        title: `gerenciar grupos de vendedores`,
        subtitle: `Gerencie seus vendedores em grupos de acordo com suas necessidades`,
        icon_title: "fas fa-users",
        cancel_text: "Voltar",
        style: {
          width: "90%",
        },
      },
      provider_name: "",
      added_provider_name: "",
      group: {
        id: null,
        nome: '',
        selected: false
      },
      new_group: {
        nome: ''
      },
		};
	},
  	methods: {
		update(group) {
			this.present_loader("Salvando grupo...")
			this.group_svc.update(group).then((response) => response.data)
			.then((data) =>  {
				this.load_groups().then(() => this.toggle_activation(data, this.groups))
			}).then(this.dismiss_loader)
		},
    deactivate(group, collection) {
      this.addBtnSelected = false;
      this.loading = true;
      collection.filter((s) => s.id !== group.id).forEach((s) => (s.selected = false));
      let g = collection.find((s) => s.id == group.id);
      g.selected = false;
      this.group_sellers = [];
      this.sellers = [];
      this.group = {};
      this.$forceUpdate();
    },
		create() {
      this.addBtnSelected = true;
			this.present_loader("Salvando grupo...")
			this.group_svc.save(this.new_group, {owner_id: this.buyer.id})
			.then((response) => response.data)
			.then((data) =>  this.load_groups()
			.then(() => this.toggle_activation(data, this.groups)))
			.then(this.dismiss_loader).then(() => {
				this.new_group = {}
				this.group_sellers = []
				this.process_sellers()
        this.loading = false;
      this.dismiss_loader();
			})
		},
		toggle_activation(group, collection) {
			collection.filter(s => s.id !== group.id).forEach(s => s.selected = false)
			let g = collection.find(s => s.id == group.id)
			g.selected = true
			this.group = g
			this.$forceUpdate()
		},
		process_sellers() {
			this.sellers.forEach(gs => gs.disabled = false)
			this.sellers.forEach(s => {
				this.group_sellers.forEach(gs => {
					if(gs.usu_id == s.id) {
						s.disabled = true
					}
				})
			})
			this.$forceUpdate()
		},
		add(seller) {
			this.$set(seller, 'loading', true)
			return this.group_svc.add_to_group(this.group.id, { seller_id: seller.id })
			.then(() => this.select_group(this.group))
			.then(() => this.$set(seller, 'loading', false))
		},
		select_group(group) {
			this.loading = true
      this.addBtnSelected = true
			return this.group_svc.load(group.id, {owner_id: this.buyer.id})
			.then(response => response.data)
			.then(data => {
				this.toggle_activation(data, this.groups);
				this.group_sellers = this.order_group_sellers(data.sellers);
				this.process_sellers()
				this.loading = false
			})
			.catch(error => {
				this.loading = false
				ErrorHandlerService.handle(error, this.$store);
			});
		},
		remove_seller(seller) {
      console.log(seller)
			this.$set(seller, 'loading', true)
			return this.group_svc.remove_from_group(this.group.id, seller.usu_id).then(() => {
				this.select_group(this.group)
			}).then(() => this.$set(seller, 'loading', false))
		},
		remove_group(group) {
      this.addBtnSelected = false;
			this.$set(group, 'loading', true)
			return this.group_svc.remove(group.id)
			.then(() => this.load_groups()).then(() => this.$set(group, 'loading', false))
		},
		close() {
			this.$emit("close");
		},
		load_sellers(page = this.page) {
			this.present_loader("Carregando vendedores disponíveis...")
			return this.group_svc.get_sellers({client_id: this.buyer.client.id, search_name: this.provider_name})
			.then(response => response.data)
			.then(data => {
				this.sellers = data.data;
				this.sellers.forEach(s => s.visible = true)
				this.filters.total_items = data.total
				this.filters.per_page = data.per_page
				this.process_sellers()
				this.dismiss_loader()
			})
			.catch(error => {
				ErrorHandlerService.handle(error, this.$store);
			});
		},
    load_added_sellers(page = this.page) {
			this.present_loader("Carregando vendedores já no grupo...");
			return this.group_svc.load(this.group.id, {owner_id: this.buyer.id, search_name: this.added_provider_name})
			.then(response => response.data)
			.then(data => {
				this.toggle_activation(data, this.groups);
				this.group_sellers = this.order_group_sellers(data.sellers);
				this.process_sellers()
				this.loading = false
        this.dismiss_loader()
			})
			.catch(error => {
				this.loading = false
				ErrorHandlerService.handle(error, this.$store);
			});
		},
		load_groups() {
			this.present_loader("Carregando grupos disponíveis...")
			return this.group_svc.all({owner_id: this.buyer.id})
			.then(response => response.data)
			.then(data => {
				this.groups = data;
				this.groups.forEach(s => s.visible = true)
				this.filters.total_group_items = data.total;
				this.dismiss_loader()
			})
			.catch(error => {
				ErrorHandlerService.handle(error, this.$store);
			});
		},
		load_request_sellers() {
			this.present_loader("Carregando vendedores do cotação...")
			return this.req_svc.sellers_in(this.request.numeroCotacao)
			.then(response => response.data)
			.then(data => {
				this.loader_msg("Alocando vendedores...")
				this.request_sellers = data.data;
				this.request_sellers.forEach(s => s.visible = true)
				this.dismiss_loader()
			})
			.catch(error => {
				ErrorHandlerService.handle(error, this.$store);
			});
		},
		filter_sellers(collection, filter = '') {
			collection.forEach(s => s.visible = false)
			collection
			.filter(s => s.usu_nome.toLowerCase().includes(filter.toLowerCase()) || s.for_nome.toLowerCase().includes(filter.toLowerCase()))
			.forEach(s => s.visible = true)
			this.$forceUpdate()
		},
        order_group_sellers(sellers){
            let result = sellers.sort(function (a, b) {
                if (a.provider.for_nome > b.provider.for_nome) {
                    return 1;
                }
                if (a.provider.for_nome < b.provider.for_nome) {
                    return -1;
                }
                return 0;
            });
            return result;
        }
	},
	mounted() {
    console.log(this.buyer)
		this.load_groups()
		this.load_sellers()
	}
};
</script>
